import {
  Message
} from 'element-ui';
import {
  InformType
} from './InformType';
/**
 * 提示訊息
 * @param {*} msg 訊息內容
 * @param {*} type 訊息類型
 */
let msgPromise = Promise.resolve();

function send(msg, type) {
  msgPromise = msgPromise
    .then(this.$nextTick)
    .then(() => {
      Message({
        message: msg,
        type: type,
        showClose: true,
        duration: type === InformType.SUCCESS ? 3000 : 6000,
      });
    });
}

export default {
  send,
};